import type { AnalyticsSource } from 'corso-admin-ui';
import api from '~/api';

// the store reads its own rows
export const storeSource = (storeId: `${number}`, currency: string) =>
  ({
    key: ['store', storeId],
    currency,
    query: (request) => api.store(storeId).analytics.query(request),
    list: (request) => api.store(storeId).analytics.lists.query(request),
  }) satisfies AnalyticsSource;

// an organization reads its stores in the source's currency alone
export const organizationSource = (organizationId: number, currency: string) =>
  ({
    key: ['organization', organizationId],
    currency,
    query: (request) =>
      api.organization(`${organizationId}`).analytics.query(request, currency),
    list: (request) =>
      api
        .organization(`${organizationId}`)
        .analytics.lists.query(request, currency),
  }) satisfies AnalyticsSource;
